import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';

import './App.css';

// ROUTES
import Home from './pages/Home.js';
import AssetManagement from './pages/AssetManagement.js';
import Securities from './pages/Securities.js';
import NewIndividualForm from './pages/IndividualAccount.js';
import CorporateForm from './pages/CorporateAccount.js';
import Products from './pages/Products.js';
import EmailVerification from './pages/EmailVerification.js';
import BVNVerification from './pages/BVNVerification.js';
import CACVerification from './pages/CACVerification.js';

function App() {
  return ( 
      <Router>
        <Routes>
          <Route exact path="/" element={<Home/>}></Route>
          <Route exact path="/home" element={<Home/>}></Route>
          
          <Route exact path="/asset-management" element={<AssetManagement/>}></Route>
          <Route exact path="/securities" element={<Securities/>}></Route>

          {/* INDIVIDUAL ROUTES */}
          <Route exact path="/new-individual-account" element={<NewIndividualForm/>}></Route>
          
          {/* CORPORATE ROUTES */}
          <Route exact path="/new-corporate-account" element={<CorporateForm/>}></Route>

          <Route exact path="/products" element={<Products  />}></Route>

          <Route exact path="/email-verification" element={<EmailVerification />}></Route>
          <Route exact path="/bvn-verification" element={<BVNVerification />}></Route>
          <Route exact path="/cac-verification" element={<CACVerification />}></Route>
        </Routes>
      </Router>
  );
}

export default App;
